import { render } from "./MenteePendingRequestsPage.vue?vue&type=template&id=1872fb0d&scoped=true"
import script from "./MenteePendingRequestsPage.vue?vue&type=script&lang=js"
export * from "./MenteePendingRequestsPage.vue?vue&type=script&lang=js"

import "./MenteePendingRequestsPage.vue?vue&type=style&index=0&id=1872fb0d&scoped=true&lang=css"
import "./MenteePendingRequestsPage.vue?vue&type=style&index=1&id=1872fb0d&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1872fb0d"]])

export default __exports__